import React from 'react';
import TypographySkeleton from '../Skeleton/Typography';
import AlertBanner from './index';
export var AlertBannerSkeleton = function AlertBannerSkeleton() {
  return /*#__PURE__*/React.createElement(AlertBanner, null, /*#__PURE__*/React.createElement(TypographySkeleton, {
    variant: "h6",
    width: 300,
    inverse: true
  }));
};
export default AlertBannerSkeleton;